module.exports = function (player_id, video_id, callback) {

  // This code loads the IFrame Player API code asynchronously.
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // This function creates an <iframe> (and YouTube player)
  // after the API code downloads.
  let player;

  function onYouTubeIframeAPIReady() {
    player = new YT.Player(player_id, {
      videoId: video_id,
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      },
      playerVars: {
        controls: 1,
        showinfo: 0,
        rel: 0,
        modestbranding: 1,
        autohide: 1
      }
    })
  }

  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

  // 4. The API will call this function when the video player is ready.
  function onPlayerReady(event) {
  }

  function onPlayerStateChange(event) {
    if(event.data === 0) {
      callback()
    }
  }

  function stop () {
    player.stopVideo()
  }

  function play () {
    if(player){
      player.playVideo()
    }
  }

  return {
    play: play,
    stop: stop
  }
}
